import Icon from '@Components/Common/Icons/Icon';
import { isMobile } from '@Constants/LeftDrawer';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { StyleSheet } from 'react-native';
import { Hoverable } from 'react-native-web-hooks';
import styled from 'styled-components/native';

import { Text } from '../../../Common/Text';
import { useSeenThingsPresenter } from '../SeenThingsPresenter';
import { SeenThingsAnimatedWrapper } from './SeenThingsAnimationWrapper';

const StyledMenu = styled.View`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${isMobile ? 3 : 6}px;
  margin: ${isMobile ? '18px 21px' : '22px 41px'};
  position: relative;
`;

const StyledMenuItemWrapper = styled.View<{
  isHovered?: boolean;
}>`
  width: 184px;
  border-radius: 60px;
  padding: ${isMobile ? '2px 0' : '5px 20px'};
  ${({ isHovered }) => isHovered && `background-color: #f6f6f6`};
`;

const StyledMenuItem = styled.Pressable<{
  active?: boolean;
}>``;

const StyledIconWrapper = styled.View`
  width: 100%;
  margin: ${isMobile ? '20px 37px' : '36px 53px 34px'};
`;
const StyledIcon = styled.Pressable`
  width: ${isMobile ? 30 : 50}px;
  height: ${isMobile ? 30 : 50}px;
  border-radius: 50%;
  background-color: #f6f6f6;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = () => {
  const { mode, closeBrandDetails } = useSeenThingsPresenter();

  const StyledHeader = styled.View`
    width: 100%;
    height: ${isMobile ? 70 : 120}px;
    box-shadow: 0px 5px 24px rgba(0, 0, 0, 0.2);
  `;

  return (
    <StyledHeader>
      <SeenThingsAnimatedWrapper type='brand'>
        <StyledMenu>
          <StyledMenuItem
            onPress={() => {
              mode.set('brand');
            }}
            active={mode.value === 'brand'}
          >
            <Hoverable>
              {(isHovered) => (
                <StyledMenuItemWrapper isHovered={isHovered && !isMobile}>
                  <Text
                    fontStyleOverride={[
                      styles.menuItem,
                      // eslint-disable-next-line react-native/no-inline-styles
                      { opacity: mode.value === 'brand' ? 1 : 0.2 },
                    ]}
                  >
                    View by brand
                  </Text>
                </StyledMenuItemWrapper>
              )}
            </Hoverable>
          </StyledMenuItem>

          <StyledMenuItem
            onPress={() => {
              mode.set('date');
            }}
            active={mode.value === 'date'}
          >
            <Hoverable>
              {(isHovered) => (
                <StyledMenuItemWrapper isHovered={isHovered && !isMobile}>
                  <Text
                    fontStyleOverride={[
                      styles.menuItem,
                      // eslint-disable-next-line react-native/no-inline-styles
                      { opacity: mode.value === 'date' ? 1 : 0.2 },
                    ]}
                  >
                    View by date
                  </Text>
                </StyledMenuItemWrapper>
              )}
            </Hoverable>
          </StyledMenuItem>
        </StyledMenu>
      </SeenThingsAnimatedWrapper>

      <SeenThingsAnimatedWrapper type='detail'>
        <StyledIconWrapper>
          <StyledIcon onPress={closeBrandDetails}>
            <Icon
              icon='ChevronLeft'
              cssColor='#000'
              cssSize={isMobile ? 26 : 36}
            />
          </StyledIcon>
        </StyledIconWrapper>
      </SeenThingsAnimatedWrapper>
    </StyledHeader>
  );
};

const styles = StyleSheet.create({
  menuItem: {
    color: OwnableTheme.colors.black,
    fontSize: OwnableTheme.fontSizesNumerical[isMobile ? 'xxxs' : 'm'],
    fontFamily: OwnableTheme.fonts.gilroy.bold,
    letterSpacing: isMobile ? 0.3 : 0.6,
  },
});

export default observer(Header);
